import React, { useEffect, useState, useMemo } from "react";
import Slider from "react-slick";
import styled from "styled-components";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const API_URL = process.env.REACT_APP_IS_PROD == "true" ? process.env.REACT_APP_API_URL_PROD : process.env.REACT_APP_API_URL_DEV


const Title = styled.h2`
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 30px;

    @media (max-width: 768px) {
       font-size: 18px;
       font-weight: bold;
    }
`;

const NextButton = (props) => {
  const { className, onClick } = props;
  return <NextButtonArrow className={`${className} next`} onClick={onClick} />
};

const PrevButton = (props) => {
  const { className, onClick } = props;
  return <PrevButtonArrow className={`${className} prev`} onClick={onClick} />
};


const NextButtonArrow = styled.div`
position: absolute;
top: 50%;
right: -60px;
transform: translateY(-50%);
z-index: 2;
cursor: pointer;
font-size: 20px; /* Match with PrevButtonArrow */
color: white;
background: #0049AC;
padding: 10px;
width: 30px; /* Ensure circular shape */
height: 30px; /* Same as width */
border-radius: 50%;
box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
transition: 0.3s;

display: flex;
align-items: center;
justify-content: center;

&:hover {
  background: #007bff;
}

@media (max-width: 768px) {
  right: -20px; /* Adjust button position */
}
`;


const PrevButtonArrow = styled.div`
position: absolute;
top: 50%;
transform: translateY(-50%);
z-index: 2;
left: -60px;
cursor: pointer;
font-size: 20px; /* Increased for better visibility */
color: white;
background: #0049AC;
padding: 10px;
width: 30px; /* Ensure it maintains a circular shape */
height: 30px; /* Same as width */
border-radius: 50%;
box-shadow: 0px 2px 5px rgba(0,0,0,0.2);
transition: 0.3s;

display: flex;
align-items: center;
justify-content: center;

&:hover {
  background: #007bff;
}

@media (max-width: 768px) {
  left: -20px; /* Adjust button position */
}

`;

const AttractionSlider = ({ destinationId, destinationName }) => {

  const [attractions, setAttractions] = useState([]);

  useEffect(() => {

    const fetchAttractions = async () => {
      try {
        const response = await fetch(`${API_URL}/web/destinations/attractions/?destid=${destinationId}`, {
          headers: {
            'X-API-Key': process.env.REACT_APP_ACCESS_API_KEY // Add API key to headers
          }
        });
        const result = await response.json();

        if (result.header.resCode === 200 && result.data.length > 0) {
          setAttractions(result.data);
        }
      } catch (error) {
        console.error('Error fetching destination data:', error);
      }
    };

    fetchAttractions();
  }, [destinationId]);

  const slidesToShow = useMemo(() => (attractions.length > 3 ? 4 : 1), [attractions]);

  const settings = {
    dots: false,
    infinite: true,
    speed: 200,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    nextArrow: <NextButton></NextButton>,
    prevArrow: <PrevButton></PrevButton>,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <>
      <br /><br />
      {attractions.length > 0 &&
        <SliderWrapper>
          <Title>Main Attractions @ {destinationName}</Title>
          <StyledSlider {...settings}>
            {attractions.map((attraction, index) => (
              <Slide key={index}>
                <AttractionImage src={attraction.image} alt={attraction.name} />
                <AttractionName>{attraction.name}</AttractionName>
              </Slide>
            ))}
          </StyledSlider>
        </SliderWrapper>}
    </>
  );
};

export default AttractionSlider;

// Styled Components
const SliderWrapper = styled.div`
  width: 90%;
  margin: auto;
`;

const StyledSlider = styled(Slider)`
  .slick-list {
    margin: 0 -10px; /* Prevents cutting off margins */
  }

  .slick-slide {
    padding: 0 10px; /* Adds space between images */
  }
`;

const Slide = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

const AttractionImage = styled.img`
  width: 100%;
  height: 250px;
  object-fit: cover;
  border-radius: 8px;
`;

const AttractionName = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 5px 10px;
  font-size: 14px;
  font-weight: bold;
  border-radius: 5px;
`;

// const NextButton = styled.div`
//   position: absolute;
//   right: -50px;
//   top: 50%;
//   transform: translateY(-50%);
//   cursor: pointer;
//   font-size: 24px;
//   color: #007bff;
// `;

// const PrevButton = styled.div`
//   position: absolute;
//   left: -50px;
//   top: 50%;
//   transform: translateY(-50%);
//   cursor: pointer;
//   font-size: 24px;
//   color: #007bff;
// `;
